import type {InjectionKey, Ref} from 'vue';

const scrollContainerKey = Symbol('scrollContainerRef') as InjectionKey<Ref<HTMLDivElement | null>>;

export {scrollContainerKey};
